import { feedItems, type FeedItem } from '@/mocks/cg51';
import SectionHeading from './SectionHeading';

function tagStyle(tag: FeedItem['tag']) {
  switch (tag) {
    case '实锤':
      return 'bg-primary-100 text-primary-700';
    case '反转':
      return 'bg-accent-100 text-accent-800';
    case '复盘':
      return 'bg-secondary-100 text-secondary-800';
    default:
      return 'bg-background-100 text-foreground-700';
  }
}

export default function NewsFeed() {
  return (
    <section id="news" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <SectionHeading
          overline="追踪快讯"
          title="实时线索流"
          note="短平快地把今天的进展记下来，不做过度解读。带标签的条目会在下方各自的时间线里展开成完整复盘。"
        />

        <div className="mx-auto max-w-3xl divide-y divide-background-200/80 border-y border-background-200/80">
          {feedItems.map((item) => (
            <div key={item.title} className="group flex flex-col gap-3 py-5 md:flex-row md:items-start md:gap-6 md:py-6">
              <div className="flex shrink-0 items-center gap-3 md:w-40 md:flex-col md:items-start md:gap-2">
                <span
                  className={`inline-flex w-fit items-center rounded-full px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap ${tagStyle(item.tag)}`}
                >
                  {item.tag}
                </span>
                <span className="text-xs text-foreground-600 tabular-nums">{item.time}</span>
              </div>
              <div className="flex-1">
                <h3 className="font-heading text-base font-semibold text-foreground-950 transition-colors group-hover:text-primary-700 md:text-lg">
                  {item.title}
                </h3>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
              </div>
              <span className="hidden shrink-0 items-center gap-1.5 text-xs font-medium whitespace-nowrap text-secondary-700 lg:inline-flex">
                <i className="ri-live-line text-sm" />
                {item.badge}
              </span>
            </div>
          ))}
        </div>

        <div className="mt-6 text-center">
          <a
            href="#news"
            className="inline-flex items-center gap-2 rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium whitespace-nowrap text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            展开更多快讯
            <i className="ri-arrow-down-s-line text-base" />
          </a>
        </div>
      </div>
    </section>
  );
}